module.exports = __webpack_public_path__ + "img/logo.3af573d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 1